import { ErrorStateProps } from '@leagueplatform/web-common-components';
import { useIntl } from '@leagueplatform/locales';

export enum ERROR_TYPES {
  API_ERROR = 'server_error',
  NO_CONNECTION = 'no_connection',
  AUTH_ERROR = 'auth_error',
}

export type ErrorMessageProps = {
  errorType?: ERROR_TYPES;
  buttonText?: string;
  headingString?: string;
  bodyString?: string;
  buttonAction?: () => void;
};

type ErrorBody = {
  heading: string;
  body: string;
  buttonText?: string;
  buttonAction?: () => void;
};

export const useErrorMessage = ({
  errorType = ERROR_TYPES.API_ERROR,
  buttonText,
  headingString,
  bodyString,
  buttonAction,
}: ErrorMessageProps) => {
  const { formatMessage } = useIntl();

  const ErrorMessages: {
    [type in ERROR_TYPES]: ErrorBody;
  } = {
    [ERROR_TYPES.API_ERROR]: {
      heading: formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' }),
      body: formatMessage({ id: 'STR_ERROR_STATE_BODY_API' }),
      buttonText: formatMessage({ id: 'STR_RELOAD' }),
      buttonAction: () => window.location.reload(),
    },
    [ERROR_TYPES.NO_CONNECTION]: {
      heading: formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' }),
      body: formatMessage({ id: 'STR_ERROR_STATE_BODY_OFFLINE' }),
    },
    [ERROR_TYPES.AUTH_ERROR]: {
      heading: formatMessage({ id: 'STR_ERROR_STATE_HEADING_GENERIC' }),
      body: formatMessage({ id: 'STR_ERROR_STATE_BODY_LOGIN_ERROR' }),
      buttonText: formatMessage({ id: 'STR_TRY_AGAIN' }),
    },
  };

  let errorContentData: ErrorStateProps = {
    headingString: ErrorMessages[errorType].heading || headingString,
    bodyString: ErrorMessages[errorType].body || bodyString,
    error: null,
  };

  const btnText = buttonText || ErrorMessages[errorType].buttonText;
  const onBtnClick = buttonAction || ErrorMessages[errorType].buttonAction;

  if (btnText && onBtnClick) {
    errorContentData = {
      ...errorContentData,
      buttonText: btnText,
      onButtonClick: onBtnClick,
    };
  }

  return errorContentData;
};
